module.exports = __webpack_public_path__ + "static/media/eyewrap3.992c5224.jpg";